<router-outlet>
    <!-- Inside some other component's template -->
    <app-spinner></app-spinner>
</router-outlet>